"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobilePageTab = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../../common");
const MobilePageTabStyled = styled_components_1.default.div `
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;

	.mobile-btn-wrap {
		padding: 0 20px 20px 20px;
		position: sticky;
		bottom: 78px;
		background: var(--color-white, #ffffff);

		.btn-container {
			margin: 0;
		}
	}

	.cancel-wrap {
		display: flex;
		gap: 4px;
		padding-bottom: 12px;

		.exit-tab {
			gap: 4px;
			.overText {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: 'Noto Sans KR', sans-serif;
				font-size: 16px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 700;
				position: relative;
			}
		}
	}

	.hr {
		margin-bottom: 14px;
	}

	.page-tab {
		display: flex;
		flex-direction: row;
		gap: 10px;
		align-items: flex-start;
		justify-content: center;
		flex-shrink: 0;
		position: relative;
		width: 100%;
	}

	.tab-item {
		height: unset;
	}

	.page-tab-button {
		padding-bottom: 4px;
	}

	&.tab-nav-wrap {
		/*
		 * 이전/다음(제출) 버튼 바는 스크롤 컨테이너(.container2) 하단에 붙어야 한다.
		 * 기본값 bottom:78px 은 스크롤 뷰포트 바닥에서 78px 위에 붙어(하단 GNB 높이만큼
		 * 이중 오프셋), 그 78px 틈으로 리스트가 비쳐 버튼 바가 중하단에 "둥둥" 떠 보였다.
		 * .bottom-nav(GNB)는 .container2 "밖"의 flex 형제라 컨테이너 바닥이 이미 GNB 위이므로
		 * bottom:0 이 올바른 고정 위치다. (팝업 경로는 MobileTabLayout 에서 이미 인라인 bottom:0)
		 */
		.mobile-btn-wrap {
			bottom: 0;
			/*
			 * 설문 평가항목처럼 스크롤되는 콘텐츠(예: 마지막 문항의 삭제/추가 버튼)가
			 * 스티키 버튼 바 뒤로 비쳐 "확인 버튼이 투명해 보이는" 문제 방지.
			 * 명시적 불투명 배경 + z-index 로 버튼 바를 스크롤 콘텐츠 위에 확실히 얹는다.
			 */
			background: #ffffff;
			z-index: 3;
		}

		.contents {
			width: 100%;
			flex: 1;

			.contens-wrap {
				display: flex;
				/*
				 * .tab-nav가 position: sticky(top:0, 높이 ≈ 47~48px)로 스크롤 시 콘텐츠 위에
				 * 고정되므로, 스크롤로 콘텐츠가 tab-nav 아래로 밀려 들어갈 때 상단(표 header/타이틀 등)이
				 * 가려지지 않도록 tab-nav 높이만큼(48px) 상단 여백을 확보. isTabMode(=.tab-nav-wrap,
				 * sticky tab-nav)일 때만 적용된다.
				 * (모바일 페이지-점 모드(else 분기)는 .tab-nav-wrap이 아니라 영향 없음)
				 */
				padding: 48px 20px 20px 20px;
				width: 100%;
				flex: 1;
				min-height: 100%;
			}
			.tab-item {
				width: 100%;
				flex: 1;
				min-height: 100%;
				height: unset !important;
			}
		}
	}

	.tab-nav {
		background: #ffffff;
		border-style: solid;
		border-color: var(--color-grey-c, #e6e8ed);
		border-width: 0px 0px 1px 0px;
		display: flex;
		flex-direction: row;
		// gap: 32px;
		gap: 18px;
		align-items: center;
		justify-content: center;
		align-self: stretch;
		flex-shrink: 0;
		position: sticky;
		/*
		 * 스크롤 컨테이너는 .body > .container2(overflow-y:auto)이고, 상단 네비(.navbar)는
		 * .container2 바깥(상단 고정)이라 .container2의 콘텐츠 상단 = 네비 바로 아래다.
		 * 따라서 top:0이어야 tab-nav가 네비 바로 아래(컨테이너 최상단)에 고정된다.
		 * top:64px(과거 네비가 스크롤에 포함되던 구조의 잔재)이면 tab-nav가 컨테이너 상단보다
		 * 64px 더 내려와, 스크롤이 없는 짧은 콘텐츠(예: 태블릿 가로 '기본정보' 탭)에서
		 * tab-nav가 콘텐츠 첫 줄을 덮어 잘려 보이던 문제 → top:0으로 보정.
		 * (isPopup일 때는 아래 인라인으로 이미 top:0을 적용 중)
		 */
		top: 0;
		z-index: 2;

		.label {
			&.on {
				border-color: var(--tur-d, #479da6);
				border-style: solid;
				border-width: 0px 0px 2px 0px;

				.label2 {
					color: var(--tur-d, #479da6);
					font-weight: var(--b4-font-weight, 700);
					font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				}
			}

			flex: 1;
			cursor: pointer;
			padding: 12px 12px 12px 12px;
			display: flex;
			flex-direction: row;
			gap: 10px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;
		}

		.label2 {
			text-align: center;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 22px);
			letter-spacing: var(--b4-letter-spacing, -0.02em);
			font-weight: var(--b4-font-weight, 400);

			position: relative;
			white-space: pre;
		}
	}
`;
exports.MobilePageTab = react_1.default.memo(({ isTabMode, activeTabIndex, tabList, content, button, setActiveTabIndex, isPopup = false, }) => {
    react_1.default.useEffect(() => {
        const index = localStorage.getItem('rememberTabIndex');
        if (index) {
            const tabIndex = JSON.parse(index);
            setActiveTabIndex(Number(tabIndex));
            localStorage.removeItem('rememberTabIndex');
        }
    }, []);
    if (isTabMode) {
        return (react_1.default.createElement(MobilePageTabStyled, { className: "tab-nav-wrap" },
            react_1.default.createElement("div", { className: "tab-nav", style: isPopup ? { top: 0 } : undefined }, Array.from({ length: tabList.length }, (_, index) => (react_1.default.createElement("div", { key: index, className: `label ${activeTabIndex === index ? 'on' : 'off'}`, onClick: setActiveTabIndex
                    ? () => {
                        setActiveTabIndex(index);
                    }
                    : undefined },
                react_1.default.createElement("div", { className: "label2" }, tabList[index].title))))),
            react_1.default.createElement("div", { className: "contents" },
                react_1.default.createElement("div", { className: "contens-wrap" }, content)),
            button));
    }
    return (react_1.default.createElement(MobilePageTabStyled, null,
        react_1.default.createElement("div", { className: "scroll-content" },
            content,
            react_1.default.createElement("div", { className: "page-tab-button" },
                react_1.default.createElement("div", { className: "hr", style: { marginTop: '14px' } }),
                react_1.default.createElement("div", { className: "page-tab" }, Array.from({ length: tabList.length }, (_, index) => (react_1.default.createElement(common_1.Icon, { key: index, icon: `page_${activeTabIndex === index ? 'on' : 'off'}`, width: 40 })))),
                button))));
});
